var map = {
	"./animate.jsx": 5,
	"./changezone.jsx": 630,
	"./chat.jsx": 382,
	"./dance.jsx": 634,
	"./dialogue.jsx": 204,
	"./face.jsx": 579,
	"./greeting.jsx": 512,
	"./index.jsx": 816,
	"./interact.jsx": 942,
	"./move.jsx": 369,
	"./patrol.jsx": 714,
	"./prompt.jsx": 25,
	"./script.jsx": 621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;